<div class="no-physical-credentials">
  <div
    class="d-flex flex-column justify-content-cneter align-items-center no-credentials px-30 py-120"
  >
    <img
      class="credential-icon pr-3"
      src="/assets/svg/ico-guestaccess-white-circle.svg"
    />
    <p class="credential-status text-center">
      {{ 'NO_PHYSICAL_CREDENTIALS' | translate }}
    </p>
    <p class="credential-description text-center">
      {{ 'THERE_ARE_NO_PHYSICAL_CREDENTIALS' | translate }}{{ userName }}
    </p>
  </div>
  <!-- MPC-7907 Commented for future use not needed for now -->
  <!--   <div class="d-flex flex-row justify-content-cneter align-items-center mt-60">
    <button type="button" class="add-button px-5 py-3 w-100">
      <strong>{{ LANG_CONST.ADD_CREDENTIAL.toUpperCase() + "+" }}</strong>
    </button>
  </div> -->
</div>
